import { render, staticRenderFns } from "./ArticleBillOfMaterialsCard.vue?vue&type=template&id=1228b562"
import script from "./ArticleBillOfMaterialsCard.vue?vue&type=script&lang=ts"
export * from "./ArticleBillOfMaterialsCard.vue?vue&type=script&lang=ts"
import style0 from "./ArticleBillOfMaterialsCard.vue?vue&type=style&index=0&id=1228b562&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports